"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RelayLogger;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _js = require("@adeira/js");

var _excluded = ["name"],
    _excluded2 = ["name"],
    _excluded3 = ["name"];

function renderQueryAvailability(queryAvailability, shouldFetch) {
  if (queryAvailability.status === 'available') {
    var fetchTime = queryAvailability.fetchTime;

    if (fetchTime != null) {
      var seconds = Math.round((Date.now() - fetchTime) / 1000);
      return "\uD83D\uDFE2 ".concat(seconds, "s old").concat(shouldFetch ? ', re-fetching' : '');
    }

    return "\uD83D\uDFE2 ".concat(shouldFetch ? 're-fetching' : '');
  } else if (queryAvailability.status === 'stale') {
    return "\uD83D\uDFE0 ".concat(shouldFetch ? 're-fetching' : '');
  } else if (queryAvailability.status === 'missing') {
    return "\uD83D\uDD34 ".concat(shouldFetch ? 'fetching' : '');
  }

  queryAvailability.status;
  return '';
}

function RelayLogger(logEvent) {
  if (!(process.env.NODE_ENV !== "production") || !(0, _js.isBrowser)()) {
    return;
  }

  if (logEvent.name === 'queryresource.retain' || logEvent.name === 'network.start' || // see `execute.start`
  logEvent.name === 'network.next' || // see `execute.next`
  logEvent.name === 'network.error' || // see `execute.error`
  logEvent.name === 'network.complete' // see `execute.complete`
  ) {// We skip some events that are not that useful for normal development.
  } else if (logEvent.name === 'execute.start') {
    // Prints information about the beginning of mutation/query/subscription (operation) execution.
    var name = logEvent.name,
        logEventParams = (0, _objectWithoutProperties2.default)(logEvent, _excluded);
    console.groupCollapsed('%c%s%c%s%c%s', 'font-weight:bold', '[Relay] ', 'font-weight:normal', "".concat(name, " "), 'font-weight:bold', logEventParams.params.name);
    console.log(logEventParams);
    console.groupEnd();
  } else if (logEvent.name === 'queryresource.fetch') {
    // Prints additional information about the presence/staleness of data and whether it's going to
    // be (re)fetched or not. See:
    //  - https://relay.dev/docs/guided-tour/reusing-cached-data/availability-of-data/
    //  - https://relay.dev/docs/guided-tour/reusing-cached-data/presence-of-data/
    //  - https://relay.dev/docs/guided-tour/reusing-cached-data/staleness-of-data/
    var _name = logEvent.name,
        _logEventParams = (0, _objectWithoutProperties2.default)(logEvent, _excluded2);

    console.groupCollapsed('%c%s%c%s%s', 'font-weight:bold', '[Relay] ', 'font-weight:normal', "".concat(_name, " "), renderQueryAvailability(_logEventParams.queryAvailability, _logEventParams.shouldFetch));
    console.log(_logEventParams);
    console.groupEnd();
  } else {
    var _name2 = logEvent.name,
        _logEventParams2 = (0, _objectWithoutProperties2.default)(logEvent, _excluded3);

    console.groupCollapsed('%c%s%c%s', 'font-weight:bold', '[Relay] ', 'font-weight:normal', _name2);
    console.log(_logEventParams2);
    console.groupEnd();
  }
}